import type { MembershipBottomBannerState } from './types';

export function initialState(): MembershipBottomBannerState {
	return {
		paymentTerm: 'monthly',
	};
}
